import React, { useEffect, useRef, useState } from 'react';
import styles from './Tooltip.module.scss';
import { capitalize, classNames } from '../../utils/helpers';
import { useDebouncedCallback } from '../../utils/hooks';
import { findReplacement } from './helpers';
export var TooltipPlacement;
(function (TooltipPlacement) {
    TooltipPlacement["TOP"] = "top";
    TooltipPlacement["TOP_START"] = "top-start";
    TooltipPlacement["TOP_END"] = "top-end";
    TooltipPlacement["RIGHT"] = "right";
    TooltipPlacement["RIGHT_START"] = "right-start";
    TooltipPlacement["RIGHT_END"] = "right-end";
    TooltipPlacement["BOTTOM"] = "bottom";
    TooltipPlacement["BOTTOM_START"] = "bottom-start";
    TooltipPlacement["BOTTOM_END"] = "bottom-end";
    TooltipPlacement["LEFT"] = "left";
    TooltipPlacement["LEFT_START"] = "left-start";
    TooltipPlacement["LEFT_END"] = "left-end";
})(TooltipPlacement || (TooltipPlacement = {}));
export var TooltipSize;
(function (TooltipSize) {
    TooltipSize["SMALL"] = "small";
    TooltipSize["MEDIUM"] = "medium";
    TooltipSize["LARGE"] = "large";
})(TooltipSize || (TooltipSize = {}));
const getClassFromPlacement = (placement) => `placement${placement.split('-').map(capitalize).join('')}`;
const getClassFromSize = (size) => `size${capitalize(size)}`;
const Tooltip = ({ id, title, placement = TooltipPlacement.BOTTOM, forcePlacement = false, size = TooltipSize.MEDIUM, show = false, onShow = undefined, onHide = undefined, children, }) => {
    const [internalPlacement, setInternalPlacement] = useState(placement);
    const containerRef = useRef(null);
    const tooltipRef = useRef(null);
    const handleReplacement = () => setInternalPlacement(forcePlacement
        ? placement
        : findReplacement(placement, tooltipRef, containerRef));
    useEffect(handleReplacement, [title, placement, forcePlacement, size]);
    const handleReplacementDebounce = useDebouncedCallback(handleReplacement, 300);
    useEffect(() => {
        window.addEventListener('resize', handleReplacementDebounce);
        return () => {
            window.removeEventListener('resize', handleReplacementDebounce);
        };
    }, []);
    return (React.createElement("div", { ref: containerRef, className: classNames(styles.container, show && styles.show), onMouseEnter: onShow, onMouseLeave: onHide },
        React.createElement("div", { id: id, ref: tooltipRef, className: classNames(styles.tooltip, styles[getClassFromPlacement(internalPlacement)], styles[getClassFromSize(size)]) }, title),
        children));
};
export default Tooltip;
